var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({class:_vm.componentClasses},_vm.$listeners),[_c('svg',{attrs:{"width":"15","height":"14","viewBox":"0 0 15 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"7.25","cy":"7","r":"5.5","fill":"#9B2A2A","stroke":"white","stroke-width":"3"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }